import { createSlice } from "@reduxjs/toolkit";
import reducers from "./bonuses.reducers";
import { IBonus, IBonuses } from "./typing/bonuses.interface";

const initialState: IBonuses = {
  bonuses: {},
  activatedBonuses: [],
  available: [],
};

export const bonusesSlice = createSlice({
  name: "bonuses",
  initialState,
  reducers,
});

export const { addBonuses, addMyActivatedBonuses, addAvailableBonuses } =
  bonusesSlice.actions;

export default bonusesSlice.reducer;
